/**
 * @module transformer
 */

/**
 * @ignore
 */
const alphabetCount = 26;
/**
 * @ignore
 */
const parseAlphaBet = (index: number) => index === 0 ? 'Z' : String.fromCharCode(index + 64);

/**
 * Transform number to alphabet.
 * @param number 
 * @param toLowerCase 
 * 
 * ```ts
 * numberToAlphabet('1') === 'A'
 * numberToAlphabet(1) === 'A'
 * numberToAlphabet(27) === 'AA'
 * numberToAlphabet(675) === 'YY'
 * numberToAlphabet(703) === 'AAA'
 * ```
 */
export function numberToAlphabet(number: number | string, toLowerCase: boolean = false): string {
	const parsedNum = parseInt(`${number}`, 10);
	if (parsedNum === 0) {
		return '';
	}
	const remainder = parsedNum % alphabetCount;
	let quotient = Math.floor(parsedNum / alphabetCount);
	if (remainder === 0) {
		quotient -= 1;
	}
	const str = `${numberToAlphabet(quotient)}${parseAlphaBet(remainder)}`;
	return toLowerCase ? str.toLowerCase() : str;
}
